// import Seo f../../../../..om '@/components/Seo/Seo'
import UserWrapper from "../../../../../layout/userwrapper/UserWrapper";
import {
  Box,
  Button,
  ButtonGroup,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography,
  tooltipClasses,
} from "@mui/material";
import React, { useRef } from "react";
import styles1 from "../../../../../styles/pages/mymessage.module.scss";
import styles from "../../../../../styles/pages/user/content-buyer-requestdetails.module.scss";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import MessagePageLeftHeading from "../../../../../components/MessagePageLeftHeading/MessagePageLeftHeading";
import PurchaseRequestVideoUrl from "../../../../../components/VideoURL/PurchaseRequestVideoUrl";
import ContentbuyerPurchaserequestAttachfiles from "../../../../../components/AttachFiles/ContentbuyerPurchaserequestAttachfiles";
import ContentbuyerPurchaserequestDecisionCard from "../../../../../components/ContentbuyerPurchaserequestDecisionCard/ContentbuyerPurchaserequestDecisionCard";
import TabBackIcon from "../../../../../ui/Icons/TabBackIcon";
import TabSaveIcon from "../../../../../ui/Icons/TabSaveIcon";
import CustomRadioOne from "../../../../../ui/Inputs/CustomRadioOne";
import people from "../../../../../public/assets/images/people.svg";
import UploadPin from "../../../../../ui/Icons/UploadPin";
import DownArrowBlue from "../../../../../ui/Icons/DownArrowBlue";
import styled from "@emotion/styled";
import PrevIcon from "../../../../../ui/Icons/PrevIcon";

const viralSnareUpload = [
  {
    name: "ViralSnare Admin",
    image: `${people}`,
    date: "September 14, 2022 at 09:08 AM UTC",
    desgnation: true,
    desgnationname: "Admin",
    paragraph: (
      <>
        Hi Maxime, <br />
        How are you doing today? <br />
        Sure, please reset your password through the following link:
        viralsnare.com/pwd_reset. <br />
        Don’t hesitate to reach back if you needed anything else! <br />
        Kind regards,
      </>
    ),
    attachedfile: false,
    attachedfilename: "",
  },
  {
    name: "Me, Myself & I",
    image: `${people}`,
    date: "September 14, 2022 at 09:08 AM UTC",
    desgnation: true,
    desgnationname: "Content Buyer",
    paragraph: (
      <>
        Hi there, <br /> I hope all is well with you! <br />I am trying to reset
        my password but it’s not letting me do it. Can you help me with this?{" "}
        <br />
        Thank you!
      </>
    ),
    attachedfile: true,
    attachedfilename: "5028537_5563370603774986.png",
  },
  {
    name: "ViralSnare Agent",
    image: `${people}`,
    date: "September 14, 2022 at 09:08 AM UTC",
    desgnation: false,
    desgnationname: "",
    paragraph: (
      <>
        Hi Maxime, <br />
        How are you doing today? <br />
        Sure, please reset your password through the following link:
        viralsnare.com/pwd_reset. <br />
        Don’t hesitate to reach back if you needed anything else! <br />
        Kind regards,
      </>
    ),
    attachedfile: false,
    attachedfilename: "",
  },
  {
    name: "John Martin",
    image: `${people}`,
    date: "September 14, 2022 at 09:08 AM UTC",
    desgnation: true,
    desgnationname: "Editor",
    paragraph: (
      <>
        Hi there, <br /> I hope all is well with you! <br />I am trying to reset
        my password but it’s not letting me do it. Can you help me with this?{" "}
        <br />
        Thank you!
      </>
    ),
    attachedfile: true,
    attachedfilename: "5028537_5563370603774986.png",
  },
  {
    name: "ViralSnare Agent",
    image: `${people}`,
    date: "September 14, 2022 at 09:08 AM UTC",
    desgnation: false,
    desgnationname: "",
    paragraph: (
      <>
        Hi Maxime, <br />
        How are you doing today? <br />
        Sure, please reset your password through the following link:
        viralsnare.com/pwd_reset. <br />
        Don’t hesitate to reach back if you needed anything else! <br />
        Kind regards,
      </>
    ),
    attachedfile: false,
    attachedfilename: "",
  },
];

const PurchaseRequestDetails = () => {
  const [sendButton, sendUpdateButton] = React.useState(false);

  const fileInput = useRef(null);
  const submitSendHandler = () => {
    sendUpdateButton(!sendButton);
  };

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#FFF",
      minWidth: 237,
      borderRadius: "5px",
      padding: "11px 13px",
      width: "100%",
      boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",

      "& .MuiTypography-root": {
        fontWeight: "500",
        fontSize: "12px",
        color: "#000",
        textAlign: "left",
        textTransform: "none"
      },
    },
  }));
  return (
    <UserWrapper headerPurchaseBtn={true} footerChatBtn={false}>
      <Paper
        elevation={0}
        className={`pageInnerWrapper ${styles.requestInnerWrapper}`}
      >
        <PerfectScrollbar className={styles.reqstInnerScroll}>
          <Stack
            direction="row"
            flexWrap="wrap"
            className={`${styles1.msgColumn} ${styles.rqstColumn}`}
          >
            <Box className={styles1.detailsColLeft}>
              <PerfectScrollbar className={styles.leftDetailsCol}>
                {/* <MessagePageLeftHeading headingText={"Request Details"} /> */}
                <Box className={styles.msgdetails}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    flexWrap="wrap"
                    className={styles1.detailsTopHeading}
                  >
                    <Typography variant="h3" className={styles1.headingStyled}>
                      Request Details
                    </Typography>
                    <Button startIcon={<PrevIcon />}>
                      Back
                    </Button>
                  </Stack>
                </Box>
                <PurchaseRequestVideoUrl />
                <ContentbuyerPurchaserequestAttachfiles />
                <ContentbuyerPurchaserequestDecisionCard type={"approved"} />
              </PerfectScrollbar>
              <Box className={styles.havePurchaseVdo}>
                <Typography variant="h4">
                  Have you purchased this video?
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <CustomRadioOne label={"Yes"} value={"yes"} />
                  <CustomRadioOne label={"No"} value={"no"} />
                </RadioGroup>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  className={styles.openVsidSec}
                >
                  <Typography variant="overline">VSID:</Typography>
                  <OutlinedInput autoComplete="off" />
                  <ButtonGroup>
                    <Button>
                      <TabBackIcon />
                    </Button>
                    <Button>
                      <TabSaveIcon />
                    </Button>
                  </ButtonGroup>
                </Stack>
              </Box>
            </Box>
            <Box className={styles.message_details_outers_rt}>
              <Box className={styles.message_fileout_div}>
                {sendButton ? (
                  <Box className={styles.respond_div_marks}>
                    <Box className={styles.respond_div_marks_outer}>
                      <List>
                        <ListItem>
                          <Button className={styles.respond_btnss}>Respond</Button>
                        </ListItem>
                        <ListItem>
                          <HtmlTooltip
                            placement="bottom-start"
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  Please indicate whether this video has been purchased to archive the request.</Typography>
                              </React.Fragment>
                            }
                          >
                            <Button className={styles.respond_unread_btn}>
                              Archive
                            </Button>
                          </HtmlTooltip>
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                ) : (
                  <Box className={styles.file_attached_textar}>
                    <Box className={styles.file_attached_textar_top}>
                      <Box className={styles.dated_file_attached}>
                        <Box className={styles.dated_file_attached_lft}>
                          <Box className={styles.editor_profile_parent}>
                            <Box className={styles.editor_profile_parent_lft}>
                              <img src={people} alt="" />
                            </Box>
                            <Box className={styles.editor_profile_parent_rtt}>
                              <Typography variant="h5" className={styles.cmn_h5}>
                                Me, Myself & I
                              </Typography>
                              <Typography
                                variant="caption"
                                className={styles.dsgntns}
                              >
                                (Content Buyer)
                              </Typography>
                            </Box>
                          </Box>
                        </Box>

                        <Box className={styles.dated_file_attached_rtt}>
                          <Typography
                            variant="caption"
                            className={styles.date_spn_main}
                          >
                            September 15, 2022 at 04:37 PM UTC
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    <Box className={styles.file_attached_textar_mdl}>
                      <form>
                        <Grid
                          container
                          spacing={2}
                          className={styles.file_attached_sec_row}
                        >
                          <Grid item xs={12}>
                            <Box className={styles.input_box_textarea}>
                              <TextField
                                multiline
                                rows={4}
                                value={
                                  "All is great! I have been able to reset my pass"
                                }
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12} className={styles.file_uploadedot_div}>
                            <Box className={styles.input_boxfile_attach}>
                              <Box
                                className={styles.input_boxfile_outer}
                                onClick={() => handleClick()}
                              >
                                <Typography variant="caption">
                                  <i>
                                    <UploadPin />
                                  </i>{" "}
                                  Attach a file
                                </Typography>
                              </Box>
                              <TextField
                                type="file"
                                className={styles.file_uploaders}
                                ref={fileInput}
                              />
                            </Box>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            className={styles.btm_option_submitted_parent}
                          >
                            <Box className={styles.btm_option_submitted}>
                              <Button className={styles.cancel_btns_pt}>
                                Cancel
                              </Button>
                              <Button
                                className={styles.submitted_btn_ps}
                                onClick={submitSendHandler}
                              >
                                Send <Typography variant="caption"> now</Typography>
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </form>
                    </Box>
                  </Box>
                )}

                <Box className={styles.agent_share_fileattchd}>
                  <Box className={styles.agent_share_fileattchd_outer}>
                    {viralSnareUpload.map((item, index) => (
                      <Box className={styles.agent_share_inners} key={index}>
                        <Box className={styles.agent_share_inners_top}>
                          <Box className={styles.share_agents_lft}>
                            <Box className={styles.agent_info_fgr_Wrap}>
                              <Box className={styles.agent_info_fgr_Wrap_img}>
                                <img src={item?.image} alt="" />
                              </Box>

                              <Box className={styles.agent_info_fgr_Wrap_content}>
                                <Typography variant="h5" className={styles.cmn_h5}>
                                  {item?.name}
                                </Typography>
                                {item?.desgnation && (
                                  <Typography
                                    variant="caption"
                                    className={styles.desg_inner}
                                  >
                                    ({item?.desgnationname})
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Box>

                          <Box className={styles.share_agents_rtt}>
                            <Typography
                              variant="caption"
                              className={styles.agent_date}
                            >
                              {item?.date}{" "}
                            </Typography>
                          </Box>
                        </Box>
                        <Box className={styles.agent_share_inners_btm}>
                          <Box className={styles.description_box}>
                            <Typography variant="body1">
                              {item?.paragraph}
                            </Typography>
                          </Box>
                          {item?.attachedfile && (
                            <Box className={styles.description_attached_boxes}>
                              <Typography variant="h5" className={styles.cmn_h5}>
                                Attached files:
                              </Typography>
                              <Button className={styles.button_pdf_styled}>
                                <i>
                                  <DownArrowBlue />
                                </i>
                                {item?.attachedfilename}
                              </Button>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Stack>
        </PerfectScrollbar>
      </Paper>
    </UserWrapper>
  );
};

export default PurchaseRequestDetails;
